$(document).ready(function() {
    $('.accordion').on('click', function(e){ 
        $(this).siblings('.accordion').find('.accordion-button').removeClass('active');
        $(this).siblings('.accordion').find('.accordion-button').addClass('collapsed');
        $(this).siblings('.accordion').find('.accordion-collapse').removeClass('show');
        $(this).siblings('.accordion').find('.accordion-collapse').css('display','none');

    });
    $('.kc_accordion_section .kc_accordion_header').on('click', function(e){
        e.preventDefault()
        e.stopPropagation()
        $(this).parent().siblings('.kc_accordion_section').removeClass('radiant-active');
        $(this).parent().toggleClass('radiant-active');
    });

    $('.kc_accordion_section').each(function(index) {

        let contentElem = $(this).find('.kc_accordion_content').get(0)

        if (contentElem) {
            contentElem.style.display = 'block !important'

            contentElem.style.setProperty('--height', `${contentElem.scrollHeight}px`)

            contentElem.style.display = ''
        }

        if (index === 0) {
            $(this).addClass('radiant-active')
        }
    })
})
